webpackJsonp([13],{

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(784);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6115710_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(830);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6115710_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_institution__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      groups: [],
      start: __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(7, 'days'),
      end: __WEBPACK_IMPORTED_MODULE_6_moment___default()()
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    setNavigatorLinks: 'navigator/setLinks',
    setNavigatorTitle: 'navigator/setTitle'
  }), {
    handleClickInstitution: function handleClickInstitution(institutionCode) {
      this.$router.push({ name: 'shares.show', params: { institutionCode: institutionCode } });
    },
    changeDate: function changeDate() {
      this.getInstitutionFavorite();
    },
    getInstitutionFavorite: function getInstitutionFavorite() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loading, start, end, res, groups, temp, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this.$loading.show();
                _context.prev = 1;
                start = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.start).format('Y-MM-DD 00:00:00');
                end = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.end).format('Y-MM-DD 23:59:59');
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__api_institution__["a" /* default */].getFavorites({ start: start, end: end });

              case 6:
                res = _context.sent;
                groups = res.data.data;
                temp = null;
                index = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.findIndex(groups, function (n) {
                  return n.employee_code === _this.$auth.user().employee_code;
                });

                if (index !== -1) {
                  temp = groups[index];
                  groups.splice(index, 1);
                  _this.groups = [temp].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(groups));
                } else {
                  _this.groups = res.data.data;
                }
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);

              case 16:
                loading.hide();

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 13]]);
      }))();
    }
  }),
  mounted: function mounted() {
    this.getInstitutionFavorite();
    this.setNavigatorLinks([]);
    this.setNavigatorTitle('シェア');
  }
});

/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shares_page"},[_c('div',{staticClass:"search_group"},[_c('div',{staticClass:"search_label"},[_vm._v("対象期間")]),_vm._v(" "),_c('div',{staticClass:"search_form"},[_c('div',{staticClass:"search_item"},[_c('el-date-picker',{attrs:{"type":"date"},on:{"change":_vm.changeDate},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}})],1),_vm._v(" "),_c('span',[_vm._v("~")]),_vm._v(" "),_c('div',{staticClass:"search_item"},[_c('el-date-picker',{attrs:{"type":"date"},on:{"change":_vm.changeDate},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"items_list white"},_vm._l((_vm.groups),function(group){return _c('div',[_c('div',{staticClass:"item"},[_c('strong',{staticClass:"text"},[_vm._v(_vm._s(group.display_name))])]),_vm._v(" "),_vm._l((group.institutions),function(institution){return _c('div',{staticClass:"item",on:{"click":function($event){return _vm.handleClickInstitution(institution.institution_code)}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(institution.official_name_kanji))]),_vm._v(" "),(institution.total_unread_messages > 0)?_c('span',{staticClass:"badge"},[_vm._v("\n                    "+_vm._s(institution.total_unread_messages > 9 ? '9+' :institution.total_unread_messages)+"\n                ")]):_vm._e()])})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.012d9f4fbc9a80428daf.js